require("@sextans/google-maps");

// Dependencies
const anime = require("animejs");
const flubber = require("flubber");

window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M440.19 376.09c-164.4-45.47-197.88 84.26-286.81 26.29-63.74-41.55-59.43-111.4 60.46-135.12 55.22-10.92 8.64-61.36 77.2-111.52 140.82-103.03 217.94 17.71 248.25-12.7C649.4 32.56 828.4 291.54 708.58 344.92c-120.57 53.72-137.28 67.44-268.39 31.17z", "M440.19,376.09C270.36,391.94,214,470,153.38,402.38C112.83,357.15,116.49,313.34,221,250c33-20,18.5-73.72,83-129c112-96,229.25,5.01,272,1c192-18,263.82,181.62,144,235C599.43,410.72,559,365,440.19,376.09z"
    ];

    let path = document.querySelector("#contact #morphing-shape");
    let interpolator = flubber.interpolate(paths[0], paths[1]);
    let progress = { interpolation: 0 };

    anime({
        targets: progress,
        interpolation: 10000,
        easing: "easeInOutQuad",
        duration: 20000,
        loop: true,
        round: 10,
        direction: "alternate",
        update: () => path.setAttribute("d", interpolator(progress.interpolation / 10000))
    });

});